import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DokumentAdditionalDataModel } from '@app/doss/models/dokument-additional-data.model';
import { AttachmentTypeModel } from '@app/common/models/attachment-type.model';
import { AttachmentTypePipeField } from '@app/common/pipes/attachment-type.pipe';

/**
 * Display type of document
 */
@Pipe({ name: 'DokumentType' })
@Injectable({ providedIn: 'root' })
export class DokumentTypePipe implements PipeTransform {

  transform(dokumentAdditionalData: DokumentAdditionalDataModel, field: AttachmentTypePipeField): string {
    const documentType = AttachmentTypeModel.createById(dokumentAdditionalData.attachmentType);

    switch (field) {
      case 'title':
        return documentType.title;
      case 'icon':
        return documentType.icon;
    }
  }
}
